module.exports = __webpack_public_path__ + "static/img/pdficon.474afe49.svg";